import {
    MapPerformanceCreatives,
    PerformanceCreativesConstructorType,
    PerformanceModalData
} from '../../typings/bannersEditState';
import { OrderInput } from '../../typings/graphql-grid';

export const SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL = 'SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL';
export type SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL = typeof SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL;

export const OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL = 'OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL';
export type OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL = typeof OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL;

export const CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL = 'CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL';
export type CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL = typeof CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL;

export const SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR = 'SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR';
export type SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR = typeof SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR;

export const LEAVE_PERFORMANCE_BANNER_CREATION = 'LEAVE_PERFORMANCE_BANNER_CREATION';
export type LEAVE_PERFORMANCE_BANNER_CREATION = typeof LEAVE_PERFORMANCE_BANNER_CREATION;

export const FETCH_PERFORMANCE_CREATIVES_START = 'FETCH_PERFORMANCE_CREATIVES_START';
export type FETCH_PERFORMANCE_CREATIVES_START = typeof FETCH_PERFORMANCE_CREATIVES_START;

export const FETCH_PERFORMANCE_CREATIVES_SUCCESS = 'FETCH_PERFORMANCE_CREATIVES_SUCCESS';
export type FETCH_PERFORMANCE_CREATIVES_SUCCESS = typeof FETCH_PERFORMANCE_CREATIVES_SUCCESS;

export const FETCH_PERFORMANCE_CREATIVES_ERROR = 'FETCH_PERFORMANCE_CREATIVES_ERROR';
export type FETCH_PERFORMANCE_CREATIVES_ERROR = typeof FETCH_PERFORMANCE_CREATIVES_ERROR;

export const PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER = 'FETCH_PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER';
export type FETCH_PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER = typeof PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER;

export const PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME = 'PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME';
export type PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME = typeof PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME;

export const SELECT_PERFORMANCE_CREATIVES = 'SELECT_PERFORMANCE_CREATIVES';
export type SELECT_PERFORMANCE_CREATIVES = typeof SELECT_PERFORMANCE_CREATIVES;

export const SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE = 'SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE';
export type SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE = typeof SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE;

export const PERFORMANCE_CREATIVE_REPLACE = 'PERFORMANCE_CREATIVE_REPLACE';
export type PERFORMANCE_CREATIVE_REPLACE = typeof PERFORMANCE_CREATIVE_REPLACE;

export interface SetVisiblePerformanceChooseCreativesModalAction {
    type: SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL;
    value: boolean;
    payload?: PerformanceModalData;
}

export function setVisiblePerformanceChooseCreativesModal(
    value: boolean,
    payload?: PerformanceModalData
): SetVisiblePerformanceChooseCreativesModalAction {
    return {
        type: SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL,
        value,
        payload
    };
}

export interface OpenPerformanceCreativesConstructorModalAction {
    type: OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL;
    constructorType: PerformanceCreativesConstructorType;
}

export function openPerformanceCreativesConstructorModal(
    modalType: PerformanceCreativesConstructorType
): OpenPerformanceCreativesConstructorModalAction {
    return {
        type: OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL,
        constructorType: modalType
    };
}

export interface SetPerformanceCreativeGroupConstructorAction {
    type: SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR;
    constructorCreativeGroupId: string;
}

export function setPerformanceConstructorCreativeGroup(
    constructorCreativeGroupId: string
): SetPerformanceCreativeGroupConstructorAction {
    return {
        type: SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR,
        constructorCreativeGroupId
    };
}

export interface ClosePerformanceCreativesConstructorModalAction {
    type: CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL;
}

export function closePerformanceCreativesConstructorModal(): ClosePerformanceCreativesConstructorModalAction {
    return {
        type: CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL
    };
}

export interface LeavePerformanceBannerCreation {
    type: LEAVE_PERFORMANCE_BANNER_CREATION;
    campaignId: string;
}

export function leavePerformanceBannerCreation(campaignId: string): LeavePerformanceBannerCreation {
    return {
        type: LEAVE_PERFORMANCE_BANNER_CREATION,
        campaignId
    };
}

export interface FetchPerformanceCreativesStartAction {
    type: FETCH_PERFORMANCE_CREATIVES_START;
    limit: number;
    offset: number;
}

export function fetchPerformanceCreativesStart(limit: number, offset: number): FetchPerformanceCreativesStartAction {
    return {
        type: FETCH_PERFORMANCE_CREATIVES_START,
        limit,
        offset
    };
}

export interface FetchPerformanceCreativesSuccessAction {
    type: FETCH_PERFORMANCE_CREATIVES_SUCCESS;
    payload: MapPerformanceCreatives;
}

export function fetchPerformanceCreativesSuccess(
    payload: MapPerformanceCreatives
): FetchPerformanceCreativesSuccessAction {
    return {
        type: FETCH_PERFORMANCE_CREATIVES_SUCCESS,
        payload
    };
}

export interface FetchPerformanceCreativesErrorAction {
    type: FETCH_PERFORMANCE_CREATIVES_ERROR;
}

export function fetchPerformanceCreativesError(): FetchPerformanceCreativesErrorAction {
    return {
        type: FETCH_PERFORMANCE_CREATIVES_ERROR
    };
}

export interface PerformanceCreativesChangeDateSortOrderAction {
    type: FETCH_PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER;
    order: OrderInput;
}

export function performanceCreativesChangeDateSortOrder(
    order: OrderInput
): PerformanceCreativesChangeDateSortOrderAction {
    return {
        type: PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER,
        order
    };
}

export interface PerformanceCreativesChangeIdOrNameAction {
    type: PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME;
    text: string;
}

export function performanceCreativesChangeIdOrName(text: string): PerformanceCreativesChangeIdOrNameAction {
    return {
        type: PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME,
        text
    };
}

export interface SelectPerformanceCreativesAction {
    type: SELECT_PERFORMANCE_CREATIVES;
    creativeIds: string[];
    value: boolean;
}

export function selectPerformanceCreatives(creativeIds: string[], value: boolean): SelectPerformanceCreativesAction {
    return {
        type: SELECT_PERFORMANCE_CREATIVES,
        creativeIds,
        value
    };
}

export interface SetPerformanceCreativeIdToReplaceAction {
    type: SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE;
    creativeId: string;
}

export function setPerformanceCreativeIdToReplace(creativeId: string): SetPerformanceCreativeIdToReplaceAction {
    return {
        type: SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE,
        creativeId
    };
}

export interface PerformanceCreativeReplaceAction {
    type: PERFORMANCE_CREATIVE_REPLACE;
}

export function performanceCreativeReplace(): PerformanceCreativeReplaceAction {
    return {
        type: PERFORMANCE_CREATIVE_REPLACE
    };
}

export type PerformanceCreativesActions =
    | SetVisiblePerformanceChooseCreativesModalAction
    | OpenPerformanceCreativesConstructorModalAction
    | ClosePerformanceCreativesConstructorModalAction
    | SetPerformanceCreativeGroupConstructorAction
    | LeavePerformanceBannerCreation
    | FetchPerformanceCreativesStartAction
    | FetchPerformanceCreativesSuccessAction
    | FetchPerformanceCreativesErrorAction
    | SelectPerformanceCreativesAction
    | PerformanceCreativesChangeDateSortOrderAction
    | PerformanceCreativesChangeIdOrNameAction
    | SetPerformanceCreativeIdToReplaceAction
    | PerformanceCreativeReplaceAction;
